/** UI identity for a folio source card (not a backend key). */
export enum FolioSourceId {
  POWERUP = 'powerup',
  EXTERNAL = 'external',
  INFINITE = 'infinite'
}

export enum SipFolioActionTone {
  DANGER = 'danger',
  SUCCESS = 'success',
  NEUTRAL = 'neutral'
}

/** One folio source row in a stop / increase / decrease sheet. */
export type SipFolioRow = {
  id: FolioSourceId
  currentAmount: number
  actionText: string | null
  actionTone: SipFolioActionTone
  helperText: string | null
  /** PowerUp partial-reduce: cancel current + start at remainingAmount. */
  powerUpRestartSteps?: { currentAmount: number; remainingAmount: number }
  interactive: boolean
}

export function sumFolioSipAmounts(recommendation: {
  powerupSipAmount?: number | null
  externalSipAmount?: number | null
  infiniteSipAmount?: number | null
}): number {
  return (
    (recommendation?.powerupSipAmount ?? 0) +
    (recommendation?.externalSipAmount ?? 0) +
    (recommendation?.infiniteSipAmount ?? 0)
  )
}
